export default "__VITE_PUBLIC_ASSET__97eceb15__"